var F = Object.freeze({
  __proto__: null,
  white: "#FFFFFF",
  black: "#061621",
  gray: {
    dark3: "#21313C",
    dark2: "#3D4F58",
    dark1: "#5D6C74",
    base: "#89989B",
    light1: "#B8C4C2",
    light2: "#E7EEEC",
    light3: "#F9FBFA"
  },
  green: {
    dark3: "#0B3B35",
    dark2: "#116149",
    base: "#13AA52",
    light2: "#C3E7CA",
    light3: "#E4F4E4"
  },
  blue: {
    dark3: "#0D324F",
    dark2: "#1A567E",
    base: "#007CAD",
    light1: "#9DD0E7",
    light2: "#C5E4F2",
    light3: "#E1F2F6"
  },
  yellow: {
    dark3: "#543E07",
    dark2: "#86681D",
    base: "#FFDD49",
    light2: "#FEF2C8",
    light3: "#FEF7E3"
  },
  red: {
    dark3: "#570B08",
    dark2: "#8F221B",
    base: "#CF4A22",
    light2: "#F9D3C5",
    light3: "#FCEBE2"
  }
});
export { F as uiColors };